// extracted by mini-css-extract-plugin
export default {"heroContainer":"Landing_heroContainer__3HK65","heroHeading":"Landing_heroHeading__mw5C9","heroDescription":"Landing_heroDescription__FtLPr"};